// src/services/Pdf.js
import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfAgritourism {
  static async gerarRelatorio(
    distrito,
    agroMapImage,
    agroturismo,
    dificuldadeAgroturismo,
    interesseAgroturismo,
    formaDeRenda,
    agroturismoImage,
    dificuldadeAgroturismoImage,
    interesseAgroturismoImage,
    formaDeRendaImage
  ) {
    const imgSize = 64;
    const propCadastrada = await Api.getNumeroPropriedadesAgroturismo(
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaDeRenda
    );
    const areaMedia = await Api.getAreaMediaAgroturismo(
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaDeRenda
    );
    let agroturismoData = await Api.getAgroturismo(
      distrito,
      interesseAgroturismo,
      dificuldadeAgroturismo,
      formaDeRenda
    );
    let interesseAgroturismoData = await Api.getInteresseAgroturismo(
      distrito,
      agroturismo,
      dificuldadeAgroturismo,
      formaDeRenda
    );
    let dificuldadeAgroturismoData = await Api.getDificuldadeAgroturismo(
      distrito,
      agroturismo,
      interesseAgroturismo,
      formaDeRenda
    );
    let formaDeRendaData = await Api.getFormaDeRenda(
      distrito,
      agroturismo,
      interesseAgroturismo,
      dificuldadeAgroturismo
    );

    agroturismoData = this.ajustarDadosBooleano(agroturismoData.value);
    interesseAgroturismoData = this.ajustarDadosInteresseAgroturismo(interesseAgroturismoData.value);
    dificuldadeAgroturismoData = this.ajustarDadosDificuldadeAgroturismo(dificuldadeAgroturismoData.value);
    formaDeRendaData = this.ajustarDadosFormaDeRenda(formaDeRendaData.value);

    const doc = new jsPDF();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Trabalha com agroturismo: ", agroturismo || "-"],
      ["Dificuldades com agroturismo: ", dificuldadeAgroturismo || "-"],
      ["Interesse em agroturismo: ", interesseAgroturismo || "-"],
      ["Formas de renda: ", formaDeRenda || "-"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades cadastradas:   ", propCadastrada.value],
      ["Área Média(ha):   ", areaMedia.value.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;
    doc.addImage(agroMapImage, "PNG", 20, y, 150, 100); // aumenta um pouco pra ver
    doc.addPage();
    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    y = 40;
    doc.text(
      `      Observa-se que ${this.calcPercentual(
        agroturismoData["01 - Não"],
        propCadastrada.value
      )}%  dos entrevistados declararam não desenvolver atividades relacionadas ao agroturismo, enquanto ${this.calcPercentual(
        agroturismoData["02 - Sim"],
        propCadastrada.value
      )}% afirmaram desenvolver atividades de agroturismo.`,
      10,
      y,
      { maxWidth: 190 }
    );

    y += 5;

    doc.addImage(
      agroturismoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(
        dificuldadeAgroturismoData["01 - Localização/Estradas"],
        propCadastrada.value
      )}% dos entrevistados apontaram localização/estradas como principal dificuldade, enquanto ${this.calcPercentual(
        dificuldadeAgroturismoData["02 - Falta de Conhecimento"],
        propCadastrada.value
      )}% relataram falta de conhecimento. Além disso, ${this.calcPercentual(
        dificuldadeAgroturismoData["03 - Falta de Estrutura"],
        propCadastrada.value
      )}% mencionaram falta de estrutura, ${this.calcPercentual(
        dificuldadeAgroturismoData["04 - Falta de Atrativos"],
        propCadastrada.value
      )}%  indicaram falta de atrativos, e ${this.calcPercentual(
        dificuldadeAgroturismoData["Não Informado"],
        propCadastrada.value
      )}%  não informaram dificuldades.`,
      10,
      y,
      { maxWidth: 190 }
    );

    y += 15;

    doc.addImage(
      dificuldadeAgroturismoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize
    );

    y += imgSize + 5;

    doc.text(
      `      Constata-se que ${this.calcPercentual(
        interesseAgroturismoData["01 - Não"],
        propCadastrada.value
      )}% dos respondentes informaram não ter interesse em agroturismo, enquanto ${this.calcPercentual(
        interesseAgroturismoData["02 - Sim"],
        propCadastrada.value
      )}% declararam ter interesse, e ${this.calcPercentual(
        interesseAgroturismoData["Não Informado"],
        propCadastrada.value
      )}% não informaram sua posição.`,
      10,
      y,
      { maxWidth: 190 }
    );

    y += 10;

    doc.addImage(
      interesseAgroturismoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize
    );

    y += imgSize + 10;

    doc.addPage();
    this.gerarCabecalho(doc, logoGente, logoPrefeitura);

    y = 40;

    doc.text(
      `      Verifica-se que ${this.calcPercentual(
        formaDeRendaData["01 - Hospedagem"],
        propCadastrada.value
      )}% dos participantes indicaram hospedagem como forma de renda vinculada ao agroturismo, enquanto ${this.calcPercentual(
        formaDeRendaData["02 - Alimentação"],
        propCadastrada.value
      )}% apontaram alimentação e ${this.calcPercentual(
        formaDeRendaData["03 - Guias/Passeios"],
        propCadastrada.value
      )}% informaram guias/passeios. Além disso, ${this.calcPercentual(
        formaDeRendaData["04 - Venda de Produtos"],
        propCadastrada.value
      )}% mencionaram venda de produtos, ao passo que ${this.calcPercentual(
        formaDeRendaData["Não Informado"],
        propCadastrada.value
      )}% não apresentaram informação.`,
      10,
      y,
      { maxWidth: 190 }
    );

    y += 10;

    doc.addImage(
      formaDeRendaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize / 2,
      y,
      imgSize,
      imgSize
    );

    const fileName =
      "Relatorio_Agroturismo_" + distrito + "_" + this.dataAtual() + ".pdf";
    doc.save(fileName);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de agroturismo das propriedades",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" }
    );
    doc.text(
      "rurais cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" }
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static ajustarDadosInteresseAgroturismo(data) {
    const chaves = ["01 - Não", "02 - Sim", "Não Informado"];

    for (let chave in chaves) {
      if (!(chave in Object.keys(data))) {
        data[chave] = 0;
      }
    }
    return data;
  }

  static ajustarDadosDificuldadeAgroturismo(data) {
    const chaves = ["01 - Localização/Estradas", "02 - Falta de Conhecimento", "03 - Falta de Estrutura", "04 - Falta de Atrativos", "Não Informado"];

    for (let chave in chaves) {
      if (!(chave in Object.keys(data))) {
        data[chave] = 0;
      }
    }
    return data;
  }

  static ajustarDadosFormaDeRenda(data) {
    const chaves = ["01 - Hospedagem", "02 - Alimentação", "03 - Guias/Passeios", "04 - Venda de Produtos", "Não Informado"];

    for (let chave in chaves) {
      if (!(chave in Object.keys(data))) {
        data[chave] = 0;
      }
    }
    return data;
  }

  static ajustarDadosBooleano(data) {
    const chaves = ["02 - Sim", "01 - Não"];

    for (let chave in chaves) {
      if (!(chave in Object.keys(data))) {
        data[chave] = 0;
      }
    }
    return data;
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfAgritourism;
